import { render, staticRenderFns } from "./caseList.vue?vue&type=template&id=a61a3f0e&scoped=true"
import script from "./caseList.vue?vue&type=script&lang=js"
export * from "./caseList.vue?vue&type=script&lang=js"
import style0 from "./caseList.vue?vue&type=style&index=0&id=a61a3f0e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a61a3f0e",
  null
  
)

export default component.exports